// opervex-frontend/src/pages/System/OperationGoodsMovement.js

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, InputGroup, Card, Button } from "react-bootstrap";
import { FaSearch, FaPlus, FaSave, FaPencilAlt } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";

import { useAuth } from "../../contexts/AuthContext";
import { SearchHelpModal } from "../../utils/SearchHelp";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";
import useOpervex from "../../hooks/useOpervex";

const rolePageRequire = "OPERATION_GM";

var dataDefault = {
  id: null,
  text: "",
  visibleAcessKey: false,
  visibleAmount: false,
  visibleKardex: false,
  visibleDepOrigin: false,
  visibleDepDestination: false,
  signDepOrigin: "",
  typeDepOrigin: null,
  signDepDestination: "",
  typeDepDestination: null,
  disabled: false,
};

const actionsDefault = {
  create: true,
  change: true,
  delete: true,
  save: true,
};

const OperationGoodsMovement = () => {
  const { roles, loadingGlobal } = useAuth();
  const [disabledField, setDisabledField] = useState(true);
  const [actions, setActions] = useState(actionsDefault);
  const [data, setData] = useState(dataDefault);
  const { id } = useParams();
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const fetchData = async () => {
      commandAction({ ...actionsDefault, create: false });

      if (id) {
        await searchAPI(id);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) {
    return <div>Carregando...</div>;
  }

  const commandAction = (actions) => {
    const hasPermission = roles.find((role) => role.command === rolePageRequire);

    if (!hasPermission) {
      setActions(actionsDefault);
      return;
    }

    if (!actions.create) actions.create = !hasPermission.actions.some((action) => action.key === "Create");
    if (!actions.change) actions.change = !hasPermission.actions.some((action) => action.key === "Change");

    setActions({ ...actions });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    var newData = { ...data, [name]: type === "checkbox" ? checked : value };

    if (name === "visibleDepOrigin") {
      newData.signDepOrigin = "";
      newData.typeDepOrigin = null;
    } else if (name === "visibleDepDestination") {
      newData.signDepDestination = "";
      newData.typeDepDestination = null;
    }

    setData(newData);
  };

  // CRUD Handlers
  const handleButtonCreate = () => {
    setData(dataDefault);
    commandAction({ ...actionsDefault, save: false });
    setDisabledField(false);
  };

  const handleButtonCancel = () => {
    if (data.id === "") {
      setData(dataDefault);
      setDisabledField(true);
      commandAction({ ...actionsDefault, create: false });
    } else {
      searchAPI(data.id);
    }
  };

  const handleButtonSave = async () => {
    var body = { ...data };

    if (body.signDepDestination === "") body.signDepDestination = null;
    if (body.signDepOrigin === "") body.signDepOrigin = null;

    if (data.id) {
      const result = await OpervexAPI.System.OperationGoodsMovement.update(body.id, body);

      if (result.errors) {
        await ConfirmService.show("Erro(s)", result.errors, true);
        return;
      }

      await searchAPI(data.id);
      alert("Registro atualizado com sucesso!");
    } else {
      const result = await OpervexAPI.System.OperationGoodsMovement.create(body);

      if (result.errors) {
        await ConfirmService.show("Erro(s)", result.errors, true);
        return;
      }

      await searchAPI(result.id);
      alert("Registro criado com sucesso!");
    }
  };

  const handleButtonSearch = async () => {
    const item = await SearchHelpModal({
      urlData: "/System/OperationGoodsMovement/SearchHelp",
      schema: await OpervexAPI.System.OperationGoodsMovement.schema(),
    });

    if (item && item.id) await searchAPI(item.id);
  };

  const handleButtonChange = async () => {
    setDisabledField(false);
    commandAction({ ...actionsDefault, save: false });
  };

  const searchAPI = async (id) => {
    setDisabledField(true);

    if (!id) return;

    var result = await OpervexAPI.System.OperationGoodsMovement.findId(id);

    if (result && !result.error) {
      setData(result);
      commandAction({ ...actionsDefault, create: false, change: false });
    } else {
      setData(dataDefault);
      commandAction({ ...actionsDefault, create: false });
      alert(result.error);
    }
  };

  return (
    <>
      <Container className="mt-2">
        <Form>
          {/* ----- Header / Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Cabeçalho</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="success" size="sm" className="me-2" onClick={handleButtonCreate} hidden={actions.create}>
                    <FaPlus /> Novo
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonChange} hidden={actions.change}>
                    <FaPencilAlt /> Alterar
                  </Button>
                  <Button variant="danger" size="sm" className="me-2" onClick={handleButtonCancel} hidden={actions.save}>
                    <MdOutlineCancel /> Cancelar
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonSave} hidden={actions.save}>
                    <FaSave /> Salvar
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Código</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" size="sm" value={data.id} name="id" onChange={handleChange} disabled={true} />

                      <InputGroup.Text size="sm" type="button" onClick={handleButtonSearch}>
                        <FaSearch />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="text"
                      maxLength={50}
                      value={data.text}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>

                <Col md={2} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="disabled"
                    checked={data.disabled}
                    name="disabled"
                    onChange={handleChange}
                    label="Inativo"
                    disabled={disabledField}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Row>
            <Col md={4}>
              <Card>
                <Card.Header>
                  <h5>Campos Visíveis</h5>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-2">
                    <Col className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        id="visibleAcessKey"
                        checked={data.visibleAcessKey}
                        name="visibleAcessKey"
                        onChange={handleChange}
                        label="Chave de Acesso"
                        disabled={disabledField}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        id="visibleKardex"
                        checked={data.visibleKardex}
                        name="visibleKardex"
                        onChange={handleChange}
                        label="Arquivo Kardex"
                        disabled={disabledField}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        id="visibleAmount"
                        checked={data.visibleAmount}
                        name="visibleAmount"
                        onChange={handleChange}
                        label="Montante"
                        disabled={disabledField}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        id="visibleDepOrigin"
                        checked={data.visibleDepOrigin}
                        name="visibleDepOrigin"
                        onChange={handleChange}
                        label="Depósito de Origem"
                        disabled={disabledField}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="d-flex align-items-center">
                      <Form.Check
                        type="checkbox"
                        id="visibleDepDestination"
                        checked={data.visibleDepDestination}
                        name="visibleDepDestination"
                        onChange={handleChange}
                        label="Depósito de Destino"
                        disabled={disabledField}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="p-0">
              <Card>
                <Card.Header>
                  <h5>Depósito de Origem</h5>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-2">
                    <Form.Group>
                      <Form.Label>Consumo:</Form.Label>
                      <Form.Select
                        size="sm"
                        value={data.signDepOrigin ? data.signDepOrigin : ""}
                        name="signDepOrigin"
                        onChange={handleChange}
                        disabled={disabledField || !data.visibleDepOrigin}
                      >
                        <option key="" value="">
                          Selecione...
                        </option>
                        <option key="-" value="-">
                          ( - ) Negatívo
                        </option>
                        <option key="+" value="+">
                          ( + ) Positívo
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Row>
                  <Row className="mb-2">
                    <Form.Group>
                      <Form.Label>Tipo:</Form.Label>
                      <Form.Select
                        size="sm"
                        value={data.typeDepOrigin ? data.typeDepOrigin : 0}
                        name="typeDepOrigin"
                        onChange={handleChange}
                        disabled={disabledField || !data.visibleDepOrigin}
                      >
                        <option key={0} value={0}>
                          Selecione...
                        </option>
                        <option key={1} value={1}>
                          Empregado
                        </option>
                        <option key={2} value={2}>
                          Físico
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <Card.Header>
                  <h5>Depósito de Destino</h5>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-2">
                    <Form.Group>
                      <Form.Label>Consumo:</Form.Label>
                      <Form.Select
                        size="sm"
                        value={data.signDepDestination ? data.signDepDestination : ""}
                        name="signDepDestination"
                        onChange={handleChange}
                        disabled={disabledField || !data.visibleDepDestination}
                      >
                        <option key="" value="">
                          Selecione...
                        </option>
                        <option key="-" value="-">
                          ( - ) Negatívo
                        </option>
                        <option key="+" value="+">
                          ( + ) Positívo
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Row>
                  <Row className="mb-2">
                    <Form.Group>
                      <Form.Label>Tipo:</Form.Label>
                      <Form.Select
                        size="sm"
                        value={data.typeDepDestination ? data.typeDepDestination : 0}
                        name="typeDepDestination"
                        onChange={handleChange}
                        disabled={disabledField || !data.visibleDepDestination}
                      >
                        <option key={0} value={0}>
                          Selecione...
                        </option>
                        <option key={1} value={1}>
                          Empregado
                        </option>
                        <option key={2} value={2}>
                          Físico
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default OperationGoodsMovement;
